export default __webpack_public_path__ + "static/media/online.3b6f1c71.svg";